import { Grid, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const FormRow = ({
  name,
  rules,
  edit,
  maxWidth,
}: {
  name: string;
  rules: object;
  edit: boolean | null;
  maxWidth: string;
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation("talentProfile");

  return (
    <>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t(name)}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field: { name, value, onChange } }) =>
            edit ? (
              <TextField
                name={name}
                sx={{ maxWidth }}
                fullWidth
                size="small"
                value={value}
                onChange={onChange}
                error={!!errors[name]}
              />
            ) : (
              <Typography>{value}</Typography>
            )
          }
        />
      </Grid>
    </>
  );
};

export default FormRow;
